<template>
  <div class="container-fluid h-100">
    <div class="row">
      <div class="col">
        <h1 class="h4 d-block float-left mt-1">{{infoTela.titulo}}</h1>
      </div>
    </div>

    <div class="card p-2 mb-2">
      <div class="row">

          <div class="col-4">
            <label for="">Descrição</label>
            <input type="text" :class="{'form-control': true, 'is-invalid':errosValidacao['Descricao']}" style="height: 34px" v-model="CamposTela.Descricao" maxlength="50">
            <div class="invalid-feedback">
              <span v-html="errosValidacao['Descricao']"></span>
            </div>
          </div>

          <div class="col-3 pl-1">
            <label for="">Mínimo</label>
            <input v-if="infoTela.tipoCadastro == 2" type="text" v-on:keypress="isNumber" :class="{'form-control': true, 'is-invalid':errosValidacao['Minimo']}" style="height: 34px" v-model="CamposTela.Minimo" maxlength="3">
            <money v-if="infoTela.tipoCadastro == 1" v-bind="money" v-model.lazy="CamposTela.Minimo" :class="{'form-control': true, 'is-invalid':errosValidacao['Minimo']}" style="height: 34px"></money>
            <input type="time" min="00:00" max="23:59" v-if="infoTela.tipoCadastro == 4" v-model="CamposTela.Minimo" :class="{'form-control': true, 'is-invalid':errosValidacao['Minimo']}" style="height: 34px"/>
            <div class="invalid-feedback">
              <span v-html="errosValidacao['Minimo']"></span>
            </div>
          </div>

          <div class="col-3 pl-1">
            <label for="">Máximo</label>
            <input v-if="infoTela.tipoCadastro == 2" v-on:keypress="isNumber" type="text" :class="{'form-control': true, 'is-invalid':errosValidacao['Maximo']}" style="height: 34px" v-model="CamposTela.Maximo" maxlength="3">
            <money v-if="infoTela.tipoCadastro == 1" v-bind="money" v-model.lazy="CamposTela.Maximo" :class="{'form-control': true, 'is-invalid':errosValidacao['Maximo']}" style="height: 34px"></money>
            <input v-if="infoTela.tipoCadastro == 4" type="time" min="00:00" max="23:59" v-model="CamposTela.Maximo" :class="{'form-control': true, 'is-invalid':errosValidacao['Maximo']}" style="height: 34px"/>
            <div class="invalid-feedback">
              <span v-html="errosValidacao['Maximo']"></span>
            </div>
          </div>
        <div class='col-2 pl-1'>
          <label for="" class="invisible w-100">.</label>
          <button class="btn btn-primary input-group-sm" style="height: 34px" @click="salvarCadastro">Salvar</button>
          <button class="btn btn-secondary ml-2" @click="limparTela" style="height: 34px" v-if="CamposTela.IdFaixaValores">Cancelar</button>
        </div>
      </div>
    </div>

    <hr class="m-1"/>

    <div class="row" v-show="DadosCadastrados.Cadastros.length === 0" style="height: calc(100% - 150px);">
        <div class="col-sm-12 pt-2 d-flex align-items-stretch justify-content-stretch">
            <div class="card text-center h-100 w-100 d-flex align-items-center justify-content-center font-size-small">
                <i class="fa fa-exclamation text-primary" style="font-size: 40px;"></i>
                <h1 class="mt-2 text-uppercase" style="font-size: 22px;" >Nenhum registro encontrado.</h1>
            </div>
        </div>
    </div>

    <div class="row" v-show="DadosCadastrados.Cadastros.length !== 0" style="height: calc(100% - 180px); overflow-y: scroll; overflow-x: hidden;">
      <div class="col-12 pr-1">
        <div v-for="item in DadosCadastrados.Cadastros" :key="item.IdFaixaValores" class="card mb-1">
          <div class="row">
            <div class="col-11">
              <span style="display: flex; justify-content: left; align-items: center;" class="pl-2 pt-4 pb-4">
                {{item.Descricao}} ({{mascararValores(item.Minimo)}} à {{mascararValores(item.Maximo)}})
              </span>
            </div>

            <div class="col-1 pl-0" style="display: flex; align-items: center; justify-content: space-evenly">
              <button class="btn btn-default" style="background-color: white" title="Alterar" v-on:click="alterarCadastro(item.IdFaixaValores)">
                <i class="fas fa-edit fa-lg"></i>
              </button>
              <button class="btn btn-default" style="background-color: white" title="Excluir" v-on:click="excluirCadastro(item.IdFaixaValores)">
                <i class="fas fa-trash-alt fa-lg"></i>
              </button>
            </div>
            
          </div>
        </div>
        </div>
    </div>
  </div>
</template>

<style scoped>
  .invalid-feedback > span {
    font-size: .875rem;
  }
</style>

<script>
import LMA from "../assets/Microservices/LMAClient.superagent";
import routes from "../assets/Microservices/Routes/BIRoutes";
import loading from '../assets/js/loading/'
import swal from '../assets/js/alerts/'

export default {
  name: "TelaCadastros",
  props: ["infoTela"],
  data() {
    return {
      CamposTela: {
        Descricao: "",
        Minimo: "",
        Maximo: "",
        IdFaixaValores: 0
      },
      errosValidacao: [],
      DadosCadastrados: {
        Cadastros: []
      },
      money: {
          decimal: ',',
          thousands: '.',
          precision: 2,
          masked: false 
      }
    };
  },
  watch: {
    "CamposTela.Descricao": function () {
      this.errosValidacao["Descricao"] = "";
    },
    "CamposTela.Minimo": function () {
      this.errosValidacao["Minimo"] = "";
    },
    "CamposTela.Maximo": function () {
      this.errosValidacao["Maximo"] = "";
    }
  },

  mounted: function() {
    this.buscarDadosIniciais();
  },

  methods: {
    buscarDadosIniciais: function() {
      var self = this;

      loading.exibir();
      var tipoCadastro = this.infoTela.tipoCadastro;

      LMA.post(routes.BI.ObterDadosIniciaisCadastros + "?tipoCadastro=" + tipoCadastro, null, function(response) {
        self.DadosCadastrados = JSON.parse(response);
        loading.ocultar();
      }, swal.exibirMensagemValidacaoApi, swal.exibirMensagemErroApi);
    },

    salvarCadastro: function() {
      var self = this;
      var mensagem = 'Cadastro realizado!';

      if (!this.validarForm()) {
        this.$forceUpdate();
        return;
      }

      loading.exibir();

      var command = {
        Descricao: this.CamposTela.Descricao,
        Minimo: parseFloat(this.CamposTela.Minimo.toString().replace(":", "")),
        Maximo: parseFloat(this.CamposTela.Maximo.toString().replace(":", "")),
        TipoCadastro: this.infoTela.tipoCadastro,
        IdFaixaValores: this.CamposTela.IdFaixaValores
      };

      var rota = routes.BI.InserirCadastro;
      if (this.CamposTela.IdFaixaValores !== 0) {
        rota = routes.BI.AlterarCadastro;
        mensagem = 'Cadastro alterado!'
      }

      LMA.post(rota, command, function(response) {
        self.DadosCadastrados.Cadastros = JSON.parse(response);
        loading.ocultar();
        self.limparTela();
        swal.exibirMensagemSucesso(mensagem);
      }, swal.exibirMensagemValidacaoApi, swal.exibirMensagemErroApi);
    },

    validarForm: function() {

      this.errosValidacao = [];

      if (this.CamposTela.Descricao == "") {
        this.errosValidacao["Descricao"] = "Você deve preencher a descrição";
      }

      if (this.CamposTela.Minimo == "") {
        this.errosValidacao["Minimo"] = "Você deve preencher o valor mínimo";
      }

      if (this.CamposTela.Maximo == "") {
        this.errosValidacao["Maximo"] = "Você deve preencher o valor máximo";
      }

      if (this.CamposTela.Maximo < this.CamposTela.Minimo) {
        swal.exibirMensagemAlerta("O valor Máximo deve ser maior do que o valor Mínimo");
        return false;
      }

      return Object.keys(this.errosValidacao).length === 0;
    },

    excluirCadastro: function(IdFaixaValores) {
      var self = this;
      loading.exibir();

      var command = {
        IdFaixaValores: IdFaixaValores
      };

      LMA.post(routes.BI.ExcluirCadastro, command, function(response) {
        self.DadosCadastrados.Cadastros = self.DadosCadastrados.Cadastros.filter(function(dado) {
          return dado.IdFaixaValores != IdFaixaValores;
        });
        swal.exibirMensagemSucesso('Cadastro excluído!')
        loading.ocultar();
      }, swal.exibirMensagemValidacaoApi, swal.exibirMensagemErroApi);
    },

    alterarCadastro: function(IdFaixaValores) {
      var cadastroFiltrado = this.DadosCadastrados.Cadastros.filter(function(dado) {
        return dado.IdFaixaValores == IdFaixaValores;
      });

      if (cadastroFiltrado.length === 0) {
        //TODO: exibir mensagem de registro não encontrado.
        return;
      }

      this.CamposTela.Descricao = cadastroFiltrado[0].Descricao;
      this.CamposTela.Minimo = this.mascararValores(cadastroFiltrado[0].Minimo);
      this.CamposTela.Maximo = this.mascararValores(cadastroFiltrado[0].Maximo);
      this.CamposTela.IdFaixaValores = cadastroFiltrado[0].IdFaixaValores;
    },

    isNumber: function (evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
          evt.preventDefault();
      }
    },

    limparTela: function() {
      var self = this;

      self.CamposTela.IdFaixaValores = 0;
      self.CamposTela.Descricao = "";
      self.CamposTela.Minimo = "";
      self.CamposTela.Maximo = "";
      self.errosValidacao = [];
    },

    mascararValores: function(valor) {

      if(this.infoTela.tipoCadastro == 4) {
        var a = ('000' + valor).substr(-4);
        a = a.substring(0, 2) + ":" + a.substring(4, 2);
        return a;
      } else if (this.infoTela.tipoCadastro == 1) {
        return "R$ " + new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(parseFloat(valor));
      } else if (this.infoTela.tipoCadastro == 2) {
        return valor 
      }
    }
  }
};
</script>